import { Link } from "gatsby";
import { useState } from "react";
import FAIcon from "../../images/icon-financial-aid.svg";
import ApplyIcon from "../../images/icon-apply.svg";
import toggle from "./toggle";
import MenuItem from "./menu-item";

const isApplicationSeason = function () {
  return new Date().getMonth() > 3 && new Date().getMonth() < 10;
};

function AdmissionMenu(props) {
  const [isAdmissionMenu, toggleAdmissionMenu] = useState(false);
  const toggleFunction = () => {
    toggle(toggleAdmissionMenu, !isAdmissionMenu);
  };

  return (
    <div
      className={`block visible hidden lg:block absolute w-full inset-x bg-white z-10 py-8 border-b-4 border-yellow-500 ${
        props.cssClass || ""
      }`}
    >
      <div className={`max-w-7xl mx-auto px-4`}>
        <ul className="flex flex-wrap -mx-2">
          <li className="w-full md:w-3/12 px-2">
            <ul className="my-2 bg-callout px-2 pt-1 pb-3 text-white shadow rounded">
              <li className="py-1">
                <Link
                  className="p-2 flex group flex-wrap rounded"
                  key="Apply"
                  to="/apply"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                >
                  <div className="flex">
                    <span className="w-2/12 mr-4">
                      <img alt="Apply" src={ApplyIcon} />
                    </span>
                    <span className="w-10/12">
                      <span className="tracking-tight group-hover:underline font-bold text-yellow-500">
                        Apply to Rollins
                      </span>
                      <p className="text-xs leading-tight text-white">
                        Ready to take the next step? We’ll walk you through the
                        process of applying to Rollins.{" "}
                      </p>
                    </span>
                  </div>
                </Link>
              </li>
              <li className="px-2 py-1">
                <a
                  href="/apply/first-time"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                  className="tracking-tight font-bold text-sm text-yellow-500 hover:underline"
                >
                  First-time applicants
                </a>
              </li>
              <li className="px-2 py-1">
                <a
                  href="/college-of-liberal-arts/transfer"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                  className="tracking-tight font-bold text-sm text-yellow-500 hover:underline"
                >
                  Transfer applicants
                </a>
              </li>
              <li className="px-2 py-1">
                <a
                  href="/apply/international"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                  className="tracking-tight font-bold text-sm text-yellow-500 hover:underline"
                >
                  International applicants
                </a>
              </li>
            </ul>
            <ul>
              <li className="px-2 inline-block py-1">
                <a
                  href="https://apply.rollins.edu/apply/status"
                  className="tracking-tight font-bold text-xs text-blue-500 hover:underline"
                >
                  Already Applied?
                </a>
              </li>
              <li className="inline-block text-xs text-gray-300">|</li>
              <li className="px-2 inline-block py-1">
                <a
                  href={
                    isApplicationSeason()
                      ? "/incoming-students"
                      : "/apply/admitted-students"
                  }
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                  className="tracking-tight font-bold text-xs text-blue-500 hover:underline"
                >
                  {isApplicationSeason()
                    ? "Incoming Students"
                    : "Admitted Students"}
                </a>
              </li>
            </ul>
          </li>
          <li className="w-full md:w-3/12 px-2">
            <ul className="my-2">
              <li className="py-1">
                <MenuItem
                  linkKey={"Apply"}
                  linkUrl={"/apply/early-decision"}
                  linkText={"Early Decision"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Know Rollins is right for you? Apply Early Decision and reap multiple rewards."
                  }
                />
              </li>
              <li className="py-1">
                <MenuItem
                  linkKey={"Apply"}
                  linkUrl={"/apply/test-optional-admission"}
                  linkText={"Test Optional Admission"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Find out how to apply without submitting SAT or ACT test scores."
                  }
                />
              </li>
              <li className="py-1">
                <MenuItem
                  linkKey={"Apply"}
                  linkUrl={"/apply/admission-counselors"}
                  linkText={"Connect With Your Counselor"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Our admission counselors are ready to guide you through applying."
                  }
                />
              </li>
            </ul>
          </li>
          <li className="w-full md:w-3/12 px-2">
            <ul className="my-2">
              <li className="py-1">
                <Link
                  className="p-2 flex group flex-wrap rounded"
                  key="Financial Aid"
                  to="/scholarships-aid"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                >
                  <div className="flex">
                    <span className="w-2/12 mr-4">
                      <img alt="Financial Aid" src={FAIcon} />
                    </span>
                    <span className="w-10/12">
                      <span className="tracking-tight group-hover:underline font-bold text-blue-500">
                        Financial Aid
                      </span>
                      <p className="text-xs leading-tight text-gray-600">
                        Explore the types of financial aid available to Rollins
                        students.
                      </p>
                    </span>
                  </div>
                </Link>
              </li>
              <li className="px-2 py-1">
                <a
                  href="/scholarships-aid/scholarships"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                  className="tracking-tight font-bold text-sm text-blue-500 hover:underline"
                >
                  Scholarships
                </a>
              </li>
              <li className="px-2 py-1">
                <a
                  href="/scholarships-aid/grants"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                  className="tracking-tight font-bold text-sm text-blue-500 hover:underline"
                >
                  Grants
                </a>
              </li>
              <li className="px-2 py-1">
                <a
                  href="/scholarships-aid/loans"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                  className="tracking-tight font-bold text-sm text-blue-500 hover:underline"
                >
                  Loans
                </a>
              </li>
              <li className="px-2 py-1">
                <a
                  href="/scholarships-aid/work-study"
                  onClick={() => {
                    toggle(toggleAdmissionMenu, !isAdmissionMenu);
                  }}
                  className="tracking-tight font-bold text-sm text-blue-500 hover:underline"
                >
                  Work Study
                </a>
              </li>
            </ul>
          </li>
          <li className="w-full md:w-3/12 px-2">
            <ul className="my-2">
              <li className="py-1">
                <MenuItem
                  linkKey={"Apply"}
                  linkUrl={"/scholarships-aid/tuition"}
                  linkText={"Tuition & Fees"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Learn more about the cost of attendance and the value of a Rollins education."
                  }
                />
              </li>
              <li className="py-1">
                <MenuItem
                  linkKey={"Apply"}
                  linkUrl={"/scholarships-aid/net-price-calculator"}
                  linkText={"Net Price Calculator"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "This simple tool estimates what it will cost you to attend Rollins."
                  }
                />
              </li>
              <li className="py-1">
                <MenuItem
                  linkKey={"Apply"}
                  linkUrl={"/scholarships-aid/faqs"}
                  linkText={"Financial Aid FAQs"}
                  toggleFunction={toggleFunction}
                  linkDescription={
                    "Easy-to-understand answers to all of your financial questions."
                  }
                />
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default AdmissionMenu;
